import device from './device'
import services from '../services'

const SESSION_ID = Math.random().toString(36).substring(2) + Date.now().toString(36)

// Where the backend lives. On the web the app is same-origin, so relative URLs
// work. The native app runs bundled assets at https://localhost, so it must call
// the deployed server directly (requires CORS on the server for this origin).
// papalist.app is the current production server (Fly app "papalist");
// papa-list.fly.dev is the LEGACY app kept alive only for old shipped builds.
const PROD_ORIGIN = 'https://papalist.app'
const isNative = !!(window as any).Capacitor?.isNativePlatform?.()
const API_ORIGIN = isNative ? PROD_ORIGIN : ''

function getSessionId() { return SESSION_ID }

function getDefaultHeader() {
    const session = services.supabase.auth.getSession()
    const accessToken = session?.access_token

    return {
        'Content-Type': 'application/json',
        'x-device-id': device.getId(),
        'x-session-id': SESSION_ID,
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
    }
}

// GET
// todo: deduplicate requests
async function get<T = any>(url: string, customHeader = {}): Promise<T> {
    try {
        const res = await fetch(API_ORIGIN + url, {
            method: 'GET',
            headers: {
                ...getDefaultHeader(),
                ...customHeader
            },
        })
        if (!res.ok) {
            const errorText = await res.text()
            throw new Error(`HTTP ${res.status}: ${errorText}`)
        }

        return await res.json() as T
    } catch (err) {
        console.error('HTTP GET Error:', err);
        throw err;
    }
}

// POST
async function post<T = { id: string }>(url: string, data: any, customHeader = {}): Promise<T> {
    
    try {
        
        const res = await fetch(API_ORIGIN + url, {
            method: 'POST',
            headers: {
                ...getDefaultHeader(),
                ...customHeader
            },
            body: JSON.stringify(data),
        })

        if (!res.ok) {
            const errorText = await res.text()
            throw new Error(`HTTP ${res.status}: ${errorText}`)
        }

        return await res.json() as T
    } catch (err) {
        console.error('HTTP POST Error:', err);
        throw err;
    }
}

// PUT
async function put<T = any>(url: string, data: any, customHeader = {}): Promise<T> {
    try {
        const res = await fetch(API_ORIGIN + url, {
            method: 'PUT',
            headers: {
                ...getDefaultHeader(),
                ...customHeader
            },
            body: JSON.stringify(data),
        })

        if (!res.ok) {
            const errorText = await res.text()
            throw new Error(`HTTP ${res.status}: ${errorText}`)
        }

        return await res.json() as T
    } catch (err) {
        console.error('HTTP PUT Error:', err);
        throw err;
    }
}

// DELETE
async function remove<T = any>(url: string, data: any, customHeader = {}): Promise<T> {
    try {
        const res = await fetch(API_ORIGIN + url, {
            method: 'DELETE',
            headers: {
                ...getDefaultHeader(),  
                ...customHeader
            },
            body: JSON.stringify(data),
        })

        if (!res.ok) {
            const errorText = await res.text()
            throw new Error(`HTTP ${res.status}: ${errorText}`)
        }

        return await res.json() as T
    } catch (err) {
        console.error('HTTP DELETE Error:', err);
        throw err;
    }
}

export default {
    post,
    put,
    get,
    remove,
    getSessionId,
    API_ORIGIN,
}
